<template>
  <div>
    <section>
      <div class="container">
        <div class="text-center">
          <h2 class="font-size-medium font-weight-bold">Configurações</h2>
        </div>
      </div>
    </section>

    <!-- TABS -->
    <section class="mt-5">
      <div class="container">
        <b-tabs
          content-class="mt-4 mt-lg-5"
          nav-class="default-tabs"
        >
          <b-tab title="Geral" active>
            <div class="sectioned-form editable-form py-md-3">
              <form
                action=""
                method="POST"
                @submit.prevent="submit"
              >
                <div class="col-lg-10 mx-auto">
                  <EditableInput
                    placeholder="Digite seu e-mail"
                    label="Seu e-mail"
                    type="email"
                    v-model="settings.email"
                    :loader="updating === 'email'"
                    @change="submit('email')"
                  />

                  <hr class="background-color2 h-1 my-4" />

                  <EditableInput
                    placeholder="Nome de usuário"
                    label="Nome de usuário"
                    complementInput="@"
                    v-model="settings.username"
                    :loader="updating === 'username'"
                    @change="submit('username')"
                  />

                  <hr class="background-color2 h-1 my-4" />

                  <EditableInput
                    placeholder="CPF"
                    label="CPF"
                    v-model="settings.document"
                    mask="###.###.###-##"
                    :loader="updating === 'document'"
                    @change="submit('document')"
                  />

                  <hr class="background-color2 h-1 my-4" />

                  <EditableInput
                    placeholder="Celular"
                    label="Celular"
                    v-model="settings.phone"
                    mask="(##) #####-####"
                    :loader="updating === 'phone'"
                    @change="submit('phone')"
                  />

                  <hr class="background-color2 h-1 my-4" />

                  <div class="d-md-flex justify-content-md-between align-items-md-center">
                    <div class="">
                      <label class="font-weight-bold text-color2 font-size-regular">Trocar senha</label>
                      <span class="d-block">Você receberá um e-mail com o processo completo.</span>
                    </div>
                    <div class="mt-4 text-center mt-md-0">
                      <Button
                        class="btn-outline-color2"
                        :loading="passwordLoader"
                        @click="reset"
                      >
                        Trocar senha
                      </Button>
                    </div>
                  </div>

                  <hr class="background-color2 h-1 my-4" />
                  <div class="d-md-flex justify-content-md-between align-items-md-center">
                    <div class="">
                      <label class="font-weight-bold text-color2 font-size-regular">Autenticação em dois fatores</label>
                      <span class="d-block col-md-9 px-0">Com a autenticação em dois fatores, você recebe um código enviado por email para finalizar seu login, garantindo assim mais segurança.</span>
                    </div>
                    <div class="mt-4 text-center mt-md-0">
                      <Button
                        :class="{
                          'btn-outline-color2': !settings.use2fa,
                          'btn-outline-color2 background-hover-color4': settings.use2fa
                        }"
                        :loading="use2faLoader"
                        @click="updateUse2fa"
                      >
                        {{ settings.use2fa  ? 'Desativar' : 'Ativar' }}
                      </Button>
                    </div>
                  </div>

                  <hr class="background-color2 h-1 my-4" />

                  <div class="d-md-flex justify-content-md-between align-items-md-center">
                    <div class="">
                      <label class="font-weight-bold text-color2 font-size-regular">Cafezinhos</label>
                      <span class="d-block">Cafezinhos são doações que usuários podem fazer diretamente para você.</span>
                      <span class="d-block font-size-xSmall">Saiba mais sobre como funciona nas nossas <router-link class="link-color2" :to="{ name: 'statics.faq' }" target="_blank">Perguntas Frequentes</router-link></span>
                    </div>
                    <div class="mt-4 text-center mt-md-0">
                      <Button
                        :class="{
                          'btn-outline-color2': !settings.is_donation_enabled,
                          'btn-outline-color2 background-hover-color4': settings.is_donation_enabled
                        }"
                        :loading="updating === 'donation'"
                        @click="toggleDonation"
                      >
                        {{ settings.is_donation_enabled  ? 'Desativar' : 'Ativar' }}
                      </Button>
                    </div>
                  </div>

                  <hr class="background-color2 h-1 my-4" />

                  <div class="d-md-flex justify-content-md-between align-items-md-center">
                    <div class="">
                      <label class="font-weight-bold text-color2 font-size-regular">Modo noturno</label>
                      <span class="d-block">Gerenciar o modo noturno.</span>
                    </div>
                    <div class="mt-4 text-center mt-md-0">
                      <Toggle
                        v-model="localNightMode"
                        @change="toggleNight"
                      />
                    </div>
                  </div>

                  <hr class="background-color2 h-1 my-4" />

                  <div class="d-md-flex justify-content-md-between align-items-md-center">
                    <div class="">
                      <label class="font-weight-bold text-color2 font-size-regular">Apagar conta</label>
                      <span class="d-block">Remover permanentemente sua conta, bem como todo seu conteúdo.</span>
                    </div>
                    <div class="mt-4 text-center mt-md-0">
                      <Button
                        class="btn-outline-color2 background-hover-color4"
                        v-b-modal.destroy-account
                      >
                        Apagar conta
                      </Button>
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </b-tab>

          <b-tab title="Notificações">
            <p class="text-center">Configure os tipos de notificações que você gostaria de receber</p>

            <div class="col-md-8 mx-md-auto mt-4">
              <div class="form-group">
                <Toggle
                  label="Ser avisado quando alguém me seguir"
                  @change="changeNotification('receive_follows_notifications')"
                  v-model="notifications.receive_follows_notifications"
                />
              </div>
              <div class="form-group">
                <Toggle
                  label="Ser avisado quando alguém comentar em uma publicação minha"
                  @change="changeNotification('receive_comments_notifications')"
                  v-model="notifications.receive_comments_notifications"
                />
              </div>
              <div class="form-group">
                <Toggle
                  label="Ser avisado quando alguém responder a um comentário que eu fiz"
                  @change="changeNotification('receive_comment_replies_notifications')"
                  v-model="notifications.receive_comment_replies_notifications"
                />
              </div>
              <div class="form-group">
                <Toggle
                  label="Ser avisado quando alguém que eu sigo postar algo novo"
                  @change="changeNotification('receive_posts_notifications')"
                  v-model="notifications.receive_posts_notifications"
                />
              </div>
            </div>
          </b-tab>

        </b-tabs>
      </div>
    </section> <!-- END TABS -->

    <UserDestroyAccountModal
      :user="user"
      v-if="user"
    />

    <UserReceivableInfoModal
      @receivable-created="refreshUser"
      v-if="user"
    />

  </div>
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import SettingsService from '@/modules/settings/services/settings-service'
import UsersService from '@/modules/users/services/users-service'
import { mapState, mapActions } from 'vuex'
import variables from '@/mixins/variables'

import Button from '@/components/common/Button/Button.vue'
import EditableInput from '@/components/common/Input/EditableInput.vue'
import Toggle from '@/components/common/Toggle/Toggle.vue'

import UserDestroyAccountModal from '@/components/user/UserDestroyAccountModal.vue'
import UserReceivableInfoModal from '@/components/user/UserReceivableInfoModal'

export default {
  components: {
    Button,
    EditableInput,
    Toggle,
    UserDestroyAccountModal,
    UserReceivableInfoModal
  },
  mixins: [variables],
  data () {
    return {
      settings: {
        email: '',
        username: '',
        document: '',
        phone: '',
        use2fa: false,
        is_donation_enabled: false
      },
      notifications: {
        receive_follows_notifications: null,
        receive_comments_notifications: null,
        receive_comment_replies_notifications: null,
        receive_posts_notifications: null
      },
      loader: false,
      updating: '',
      passwordLoader: false,
      use2faLoader: false,
      localNightMode: false
    }
  },
  metaInfo: {
    title: 'Configurações'
  },
  created () {
    this.setSettings()
    this.getNotificationSettings()
    this.localNightMode = this.nightMode
  },
  watch: {
    user () {
      this.setSettings()
      this.getNotificationSettings()
    },
    nightMode (newValue) {
      this.localNightMode = newValue
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    })
  },
  methods: {
    setSettings () {
      if (this.user) {
        this.settings.email = this.user.email
        this.settings.username = this.user.username
        this.settings.document = this.user.document
        this.settings.phone = this.user.phone
        this.settings.use2fa = this.user.use_2fa
        this.settings.is_donation_enabled = this.user.is_receivable_configured && this.user.is_donation_enabled
      }
    },
    ...mapActions(['setNightMode']),
    async getNotificationSettings () {
      if (this.user) {
        try {
          const notificationsSettings = await SettingsService.getSettings({ userId: this.user.id })
          this.notifications.receive_follows_notifications = notificationsSettings.receive_follows_notifications
          this.notifications.receive_comments_notifications = notificationsSettings.receive_comments_notifications
          this.notifications.receive_comment_replies_notifications = notificationsSettings.receive_comment_replies_notifications
          this.notifications.receive_posts_notifications = notificationsSettings.receive_posts_notifications
        } catch (error) {
          error.handleGlobally && error.handleGlobally()
        }
      }
    },
    async submit (field) {
      this.updating = field
      // creating a object with only the field that is being updated
      // so we can use correctly the validation rules on back end
      const obj = {}
      obj[field] = this.settings[field]
      try {
        await UsersService.update(this.user.id, obj)
        await UsersService.me()
        const notification = {
          notification: {
            type: 'success',
            content: 'Dados alterados com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.updating = ''
    },
    /**
     * Get user again
     */
    async refreshUser () {
      await UsersService.me()
    },
    async reset () {
      this.passwordLoader = true
      try {
        await AuthService.sendResetPasswordEmail(this.user.email)
        const notification = {
          notification: {
            type: 'success',
            content: 'Enviamos um email com as instruções para troca de senha'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.passwordLoader = false
    },
    /**
     * Toggle donations or open receivable config modal
     */
    async toggleDonation () {
      if (this.user.is_receivable_configured && this.user.recipient_status === 'active') {
        this.updating = 'donation'
        try {
          await SettingsService.toggleDonation()
          this.settings.is_donation_enabled = !this.settings.is_donation_enabled
          const notificationContent = this.settings.is_donation_enabled ? 'Cafezinhos habilitados com sucesso!' : 'Cafezinhos desabilitados com sucesso'

          const notification = {
            notification: {
              type: 'success',
              content: notificationContent
            }
          }
          NotificationService.createGlobalSuccessNotification(notification)
          await this.refreshUser()
        } catch (error) {
          error.handleGlobally && error.handleGlobally()
        }
        this.updating = ''
      } else {
        this.$bvModal.show('user-receivable-info')
      }
    },
    async updateUse2fa () {
      this.use2faLoader = true
      try {
        await SettingsService.update2fa()
        this.settings.use2fa = !this.settings.use2fa
        const notificationContent = this.settings.use2fa === false ? 'Desativamos a autenticação em dois fatores do seu perfil' : 'Ativamos a autenticação em dois fatores no seu perfil'

        const notification = {
          notification: {
            type: 'success',
            content: notificationContent
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.use2faLoader = false
    },
    async changeNotification (key) {
      try {
        if (this.user) {
          const data = {
            key,
            value: this.notifications[key]
          }
          await SettingsService.update(data)
          this.getNotificationSettings()
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    toggleNight (event) {
      localStorage.setItem('nightMode', !this.nightMode)
      this.setNightMode({ status: !this.nightMode })
    }
  }
}
</script>
